interface RoomCountProps {
  // Attendees currently in the room (currently_in), or null before first load.
  count: number | null;
}

// Bottom strip on the scan screen showing live room occupancy, so operators
// always see how many people are currently inside. Fed by currently_in from
// GET /events/:eventId/counts.
//
// CR-03: pad the bottom with env(safe-area-inset-bottom) + an extra ~18px so
// the counter sits clear of the iOS Safari URL bar regardless of whether it
// is expanded or collapsed. The inline style is the only way to use the
// `env(safe-area-inset-bottom)` CSS env() variable without bringing in a
// Tailwind plugin.
export function RoomCount({ count }: RoomCountProps): JSX.Element {
  return (
    <div
      data-testid="room-count"
      className="flex items-baseline justify-center gap-2 border-t border-slate-800 bg-slate-900 px-4 pt-2"
      style={{
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 18px)"
      }}
    >
      <span className="text-sm uppercase tracking-wide text-slate-400">
        In room
      </span>
      <span className="text-2xl font-bold tabular-nums text-white">
        {count ?? "—"}
      </span>
    </div>
  );
}
